import type { Configuration } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: `${window.location.origin}/auth`,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    // Lightweight blank page used by MSAL's hidden iframe for silent token refresh.
    // Pointing it at the SPA root boots Vue inside the iframe and causes monitor_window_timeout.
    iframeBridgeTimeout: 10000,
  },
}

export const iframeRedirectUri = `${window.location.origin}/blank.html`

export const apiScope = import.meta.env.VITE_API_SCOPE

export const loginRequest = {
  scopes: [apiScope],
}

export const tokenRequest = {
  scopes: [apiScope],
}
